// GoLiveContext.jsx
import { createContext, useContext, useEffect } from "react";
import { useGoLiveStatus } from "../../../hooks/school/golive/useGoLiveStatus";

const GoLiveContext = createContext(null);

export const GoLiveProvider = ({ children }) => {
  const { data, loading, getGoLiveStatus } = useGoLiveStatus();

  useEffect(() => {
    getGoLiveStatus();
  }, []);

  return (
    <GoLiveContext.Provider value={{ data, loading, refresh: getGoLiveStatus }}>
      {children}
    </GoLiveContext.Provider>
  );
};

export const useGoLiveContext = () => useContext(GoLiveContext);
